import React, { useState } from 'react';
import { KPI_REGISTRY, KPI_CATEGORIES } from '../constants/kpiRegistry';

interface KpiSidebarProps {
  selectedKpis: string[];
  onSave: (kpis: string[]) => void;
  onClose: () => void;
  lang?: string;
}

export default function KpiSidebar({ selectedKpis, onSave, onClose, lang = 'sv' }: KpiSidebarProps) {
  const [selected, setSelected] = useState<string[]>([...selectedKpis]);

  const toggle = (id: string) => {
    setSelected(prev => prev.includes(id) ? prev.filter(k => k !== id) : [...prev, id]);
  };

  const handleSave = () => {
    onSave(selected);
    onClose();
  };

  const categories = Object.entries(KPI_CATEGORIES);

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 1050 }} onClick={onClose}>
      <div
        className="bg-white shadow-lg d-flex flex-column"
        style={{ position: 'fixed', top: 'var(--app-env-bar-height, 0px)', bottom: 0, right: 0, width: 380, maxWidth: '90vw', zIndex: 1051 }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <h6 className="mb-0">
            <i className="feather-settings me-2"></i>
            {lang === 'en' ? 'Configure KPIs' : 'Konfigurera KPI:er'}
          </h6>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        {/* Body */}
        <div className="flex-grow-1 overflow-auto p-3">
          <p className="text-muted small mb-3">
            {lang === 'en'
              ? 'Select which KPIs to show on your dashboard.'
              : 'Välj vilka nyckeltal som ska visas på din startsida.'}
          </p>

          {categories.map(([catKey, cat]) => {
            const kpis = KPI_REGISTRY.filter(k => k.category === catKey);
            return (
              <div key={catKey} className="mb-3">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <i className={`feather-${cat.icon} text-muted`} style={{ fontSize: 14 }}></i>
                  <small className="fw-bold text-uppercase text-muted" style={{ fontSize: 11, letterSpacing: 0.5 }}>
                    {lang === 'en' ? cat.label_en : cat.label_sv}
                  </small>
                </div>
                {kpis.map(kpi => (
                  <div
                    key={kpi.id}
                    className={`d-flex align-items-center gap-2 p-2 rounded mb-1 ${selected.includes(kpi.id) ? 'border border-primary' : 'border'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggle(kpi.id)}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input flex-shrink-0"
                      checked={selected.includes(kpi.id)}
                      onChange={() => toggle(kpi.id)}
                      onClick={e => e.stopPropagation()}
                    />
                    <div className="flex-grow-1">
                      <div style={{ fontSize: 13, fontWeight: 600 }}>
                        <i className={`feather-${kpi.icon} me-1`} style={{ fontSize: 12 }}></i>
                        {lang === 'en' ? kpi.label_en : kpi.label_sv}
                      </div>
                      <small className="text-muted" style={{ fontSize: 11 }}>
                        {lang === 'en' ? kpi.description_en : kpi.description_sv}
                      </small>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="p-3 border-top d-flex justify-content-between align-items-center">
          <small className="text-muted">{selected.length} {lang === 'en' ? 'selected' : 'valda'}</small>
          <div className="d-flex gap-2">
            <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>
              {lang === 'en' ? 'Cancel' : 'Avbryt'}
            </button>
            <button className="btn btn-sm btn-primary" onClick={handleSave}>
              <i className="feather-check me-1"></i>
              {lang === 'en' ? 'Save' : 'Spara'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
